import { render, staticRenderFns } from "./ArchiveDocuments.vue?vue&type=template&id=5ad107f0&"
import script from "./ArchiveDocuments.vue?vue&type=script&lang=js&"
export * from "./ArchiveDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports